import { FdcpCity } from 'fdcp/fdcp-types';
import { SelectOptionType } from 'utils/react-table';
import TournamentDto from './tournament-dto';

type CityDto = {
    id?: number;
    fdcpId: string;
    name: string;
    country: string;
    state?: string | null;
    timeZoneId?: string;
    timeZone?: string;
    tournaments?: TournamentDto[];
    created?: string;
    modified?: string;
};

export const mapFdcpCityToCityDto = (city: FdcpCity): CityDto => ({
    fdcpId: city.IdCity,
    name: city.Name,
    country: city.Country,
    state: city.State,
    timeZoneId: city.TimeZoneId,
});

export const mapCityToSelectOption = (cities: Array<CityDto>): Array<SelectOptionType> => {
    return cities
        .filter((city): city is CityDto & { id: number } => !!city.id)
        .map((city) => ({
            value: city.id,
            label: `${city.name} - [${city.fdcpId}]`,
        }));
};

export default CityDto;
